
import { PlayerScore } from "@/store/modules/Room";
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  computed: {
    ...mapGetters({
      roundScore: "getRoundScore",
      finalScores: "getFinalScores",
      gameEnded: "getGameEnded",
      playerId: "getPlayerId",
    }),
    scores(): PlayerScore[] {
      if (this.gameEnded) {
        return this.finalScores as PlayerScore[];
      } else {
        return this.roundScore as PlayerScore[];
      }
    },
  },
});
